<p-dialog
	[(visible)]="displayDialog"
	[style]="
		isMobileDevice()
			? { width: '100vw', height: '100vh' }
			: { width: '70vw', maxHeight: '95vh', minHeight: '750px' }
	"
	[contentStyle]="isMobileDevice() ? { overflowY: 'auto', overflowX: 'hidden', maxHeight: 'calc(100vh - 120px)' } : { overflowY: 'auto', overflowX: 'hidden' }"
	(onHide)="closeDialog()"
	styleClass="pdf-viewer-dialog"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	[maximizable]="true"
	[breakpoints]="{ '768px': '100vw' }"
	[closable]="false"
	[dismissableMask]="false"
	[position]="isMobileDevice() ? 'top' : 'center'"
>
	<ng-template pTemplate="header">
		<div class="d-flex align-items-center justify-content-between" style="width:100%">
			<div class="dialog-title">{{ getModalTitle() }}</div>
			<div class="d-flex align-items-center" style="gap:8px">
				<p-dropdown
					*ngIf="showLanguageSelector"
					[options]="availableLanguages"
					[(ngModel)]="selectedLanguage"
					optionLabel="name"
					optionValue="code"
					(onChange)="handleLanguageChange($event)"
					styleClass="language-selector-dropdown"
					[placeholder]="getCurrentLanguageName()"
					[showClear]="false"
					[filter]="false"
					[style]="getDropdownStyle()"
				>
				</p-dropdown>
								<p-button
					*ngIf="hasAllocationDenial"
					icon="pi pi-cog"
					[label]="'allDocuments.actions.allocationActions' | translate"
					styleClass="p-button-sm p-button-warning"
					(onClick)="openAllocationDenialActions()"
				>
				</p-button>
			</div>
		</div>
	</ng-template>
	<ng-container *ngIf="pdfLoading">
		<div class="pdf-loading-container">
			<div class="pdf-loading-spinner">
				<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
				<p>
					{{
						isChangingDocumentLanguage
							? translateKeyLocal('allDocuments.modal.changingLanguage')
							: translateKeyLocal('allDocuments.modal.loading')
					}}
				</p>
			</div>
		</div>
	</ng-container>

	<div class="template-host">
		<div #templateContainer class="template-host-inner"></div>
	</div>
	<ng-template pTemplate="footer">
		<div
			class="d-flex align-items-center justify-content-between gap-2"
			style="position: relative"
		>
			<div class="d-flex align-items-center gap-2">
				<p-button
					*ngIf="!isMobileDevice()"
					icon="pi pi-print"
					[label]="translateGlobal('allDocuments.modal.print')"
					styleClass="p-button-sm button-icon-space mobile-button"
					(onClick)="printDocument()"
				></p-button>
				<div class="share-menu-wrap">
					<button
						#shareTriggerBtn
						pButton
						type="button"
						class="p-button-sm button-icon-space mobile-button share-trigger-btn"
						[icon]="isDownloading ? 'pi pi-spin pi-spinner' : 'pi pi-share-alt'"
						[label]="
							isMobileDevice()
								? ''
								: (isDownloading
									? translateGlobal('allDocuments.modal.preparingFile')
									: translateGlobal('allDocuments.modal.shareOriginal'))
						"
						[attr.aria-label]="translateGlobal('allDocuments.modal.shareOriginal')"
						[attr.aria-expanded]="showShareDropdown"
						aria-haspopup="menu"
						[disabled]="isDownloading"
						(click)="openShareMenu($event)"
					></button>

					<div
						*ngIf="showShareDropdown && !isMobileDevice()"
						class="share-dropdown-backdrop"
						(click)="closeShareMenu()"
					></div>
					<div
						*ngIf="showShareDropdown && !isMobileDevice()"
						class="share-dropdown-panel"
						[class.share-dropdown-panel--below]="shareDropdownOpensBelow"
						[class.share-dropdown-panel--align-end]="shareDropdownAlignEnd"
						role="menu"
						[attr.aria-label]="translateGlobal('allDocuments.modal.shareOriginal')"
					>
						<button
							*ngFor="let item of shareMenuItems"
							type="button"
							class="share-dropdown-panel__item"
							role="menuitem"
							(click)="runShareMenuAction(item)"
						>
							<i [class]="item.icon || ''" aria-hidden="true"></i>
							<span>{{ item.label }}</span>
						</button>
					</div>
				</div>
			</div>

			<p-button
				icon="pi pi-times"
				[label]="isMobileDevice() ? '' : translateGlobal('modal.common.close')"
				styleClass="p-button-sm p-button-danger button-icon-space mobile-button"
				(onClick)="closeDialog()"
				[pTooltip]="isMobileDevice() ? translateGlobal('modal.common.close') : null"
				tooltipPosition="top"
			></p-button>
		</div>
	</ng-template>
</p-dialog>

<!-- Mobile: bottom sheet share actions (popup menu is clipped in fullscreen dialog) -->
<p-dialog
	[(visible)]="showMobileShareSheet"
	[modal]="true"
	[draggable]="false"
	[closable]="true"
	[showHeader]="false"
	[dismissableMask]="true"
	styleClass="mobile-share-sheet"
	[style]="{ width: '100vw', maxWidth: '100vw', margin: 0 }"
	position="bottom"
	(onHide)="showMobileShareSheet = false"
>
	<div class="mobile-share-sheet__title">
		{{ translateGlobal('allDocuments.modal.shareOriginal') }}
	</div>
	<div class="mobile-share-sheet__list">
		<button
			*ngFor="let item of shareMenuItems"
			pButton
			type="button"
			class="p-button-text mobile-share-sheet__action"
			[icon]="item.icon || ''"
			[label]="item.label || ''"
			(click)="runShareMenuAction(item)"
		></button>
	</div>
</p-dialog>

<!-- Email Dialog -->
<p-dialog
	[(visible)]="showEmailDialog"
	[modal]="true"
	[closable]="true"
	[draggable]="false"
	[resizable]="false"
	[style]="{ width: '520px', maxWidth: '90vw' }"
	[header]="translateGlobal('allDocuments.modal.addEmail.title')"
	styleClass="email-dialog"
	(onHide)="onCancelEmailDialog()">
	
	<div class="email-dialog-content">
		<form [formGroup]="emailForm" class="email-form">
			<!-- Email Input Section -->
			<div class="email-input-section">
				<label for="customerEmail" class="email-label">
					<i class="pi pi-envelope email-label-icon"></i>
					<span>{{ translateGlobal('allDocuments.modal.addEmail.emailPlaceholder') }}</span>
				</label>
				<span class="p-input-icon-right email-input-wrapper">
					<i class="pi pi-envelope email-input-icon"></i>
					<input
						pInputText
						type="email"
						id="customerEmail"
						formControlName="email"
						class="email-input"
						[placeholder]="translateGlobal('allDocuments.modal.addEmail.emailPlaceholder')"
						[ngClass]="{ 
							'p-invalid': emailForm.get('email')?.invalid && (emailForm.get('email')?.dirty || emailForm.get('email')?.touched),
							'p-valid': emailForm.get('email')?.valid && emailForm.get('email')?.dirty
						}" />
				</span>
				<div *ngIf="emailForm.get('email')?.invalid && (emailForm.get('email')?.dirty || emailForm.get('email')?.touched)"
					class="email-error-message">
					<i class="pi pi-exclamation-circle"></i>
					<span *ngIf="emailForm.get('email')?.errors?.['required']">
						{{ translateGlobal('allDocuments.modal.addEmail.emailPlaceholder') }}
					</span>
					<span *ngIf="emailForm.get('email')?.errors?.['email']">
						{{ 'shared.addCustomerModal.validation.emailInvalid' | translate }}
					</span>
				</div>
			</div>
			
			<!-- Checkbox Section -->
			<div class="email-checkbox-section">
				<div class="email-checkbox-wrapper">
					<p-checkbox
						formControlName="savePermanently"
						inputId="savePermanently"
						[binary]="true"
						styleClass="email-checkbox">
					</p-checkbox>
					<label for="savePermanently" class="email-checkbox-label">
						<i class="pi pi-save email-checkbox-icon"></i>
						<span>{{ translateGlobal('allDocuments.modal.addEmail.savePermanently') }}</span>
					</label>
				</div>
			</div>
		</form>
	</div>
	
	<ng-template pTemplate="footer">
		<div class="email-dialog-footer">
			<p-button
				[label]="translateGlobal('allDocuments.modal.addEmail.cancel')"
				icon="pi pi-times"
				styleClass="p-button-outlined p-button-secondary email-dialog-button"
				(onClick)="onCancelEmailDialog()"
				[disabled]="isDownloading">
			</p-button>
			<p-button
				[label]="translateGlobal('allDocuments.modal.addEmail.send')"
				icon="pi pi-send"
				styleClass="p-button-primary email-dialog-button email-dialog-button-primary"
				(onClick)="onSendEmailFromDialog()"
				[disabled]="emailForm.invalid || isDownloading"
				[loading]="isDownloading">
			</p-button>
		</div>
	</ng-template>
</p-dialog>
